export class Tag {
    id: string;
    name: string;
    count: number;

    get category(): string {
        const index = this.name.indexOf('|');
        if (index === -1) {
            return null;
        }

        return this.name.substr(0, index);
    }

    get displayName(): string {
        const index = this.name.indexOf('|');
        if (index === -1) {
            return this.name;
        }

        return this.name.substr(index + 1);
    }

    set displayName(value: string) {
        const category = this.category;
        if (category === null) {
            this.name = value;
        } else {
            this.name = `${category}|${value}`;
        }
    }
}

export enum TagEditState {
    Any,
    Add,
    Remove,
}

export class TagEditView {
    tag: Tag;
    state: TagEditState;

    constructor(tag: Tag) {
        this.tag = tag;
        this.state = TagEditState.Any;
    }
}
